import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(4),
    },
  },
  emptyLabel: {
    display: 'flex',
    padding: [theme.spacing(1)],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
    [theme.breakpoints.up('mobile')]: {
      marginTop: theme.spacing(2),
    },
  },
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 32,
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/FavoriteLoanOfficersList/useStyles.js